module.exports = __webpack_public_path__ + "img/fullscreen.beab1f34.svg";